"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getPrivacySingletonObject() {
  const privacySingletonPath = ['_axpScriptSupplier', '_internal', 'scriptSupplierPrivacySingleton'];
  let privacySingletonObject = window;
  privacySingletonPath.forEach(prop => {
    if (typeof privacySingletonObject[prop] !== 'object' || privacySingletonObject[prop] === null) {
      privacySingletonObject[prop] = {};
    }
    privacySingletonObject = privacySingletonObject[prop];
  });
  return privacySingletonObject;
}
var _default = getPrivacySingletonObject;
exports.default = _default;